import { useTranslation } from "react-i18next";
import "../../i18n";
import type { InboundState, InboundTabCounts } from "../../api/inbound";
import styles from "./inbound.module.css";

export type InboundTab = "in-flight" | "held" | "landed" | "rejected";

export const TAB_STATE: Record<InboundTab, InboundState> = {
  "in-flight": "in_flight",
  held: "held",
  landed: "landed",
  rejected: "error",
};

const TAB_LABEL: Record<InboundTab, string> = {
  "in-flight": "In flight",
  held: "Held",
  landed: "Landed",
  rejected: "Rejected",
};

const TAB_LABEL_KEY: Record<InboundTab, string> = {
  "in-flight": "inbound.tabs.inFlight",
  held: "inbound.tabs.held",
  landed: "inbound.tabs.landed",
  rejected: "inbound.tabs.rejected",
};

export function InboundTabs({
  tab,
  counts,
  showHeld,
  onSelect,
}: {
  tab: InboundTab;
  counts: InboundTabCounts;
  showHeld: boolean;
  onSelect: (next: InboundTab) => void;
}) {
  const { t } = useTranslation();
  const tabs: InboundTab[] = showHeld
    ? ["in-flight", "held", "landed", "rejected"]
    : ["in-flight", "landed", "rejected"];
  return (
    <div className={styles.tabs} role="tablist" aria-label={t("inbound.tabs.ariaLabel", "Received documents")}>
      {tabs.map((key) => (
        <button
          key={key}
          type="button"
          role="tab"
          id={`inbound-tab-${key}`}
          aria-selected={key === tab}
          aria-controls="inbound-panel"
          className={`${styles.tab}${key === tab ? ` ${styles.tabOn}` : ""}`}
          onClick={() => onSelect(key)}
        >
          {t(TAB_LABEL_KEY[key], TAB_LABEL[key])}
          <span className={`${styles.tabCount} num`}>{counts[TAB_STATE[key]]}</span>
        </button>
      ))}
    </div>
  );
}
